"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyOffboardingReason = exports.CompanyOffboardingState = exports.CompanyOffboardingCategory = exports.OffboardingStepName = void 0;
var OffboardingStepName;
(function (OffboardingStepName) {
    OffboardingStepName["CANCEL_DIRECT_DEBIT_AGREEMENT"] = "CANCEL_DIRECT_DEBIT_AGREEMENT";
    OffboardingStepName["CANCEL_SUBSCRIPTION"] = "CANCEL_SUBSCRIPTION";
    OffboardingStepName["CREDIT_PENDING_INVOICES"] = "CREDIT_PENDING_INVOICES";
    OffboardingStepName["DEACTIVATE_USERS"] = "DEACTIVATE_USERS";
    OffboardingStepName["DEACTIVATE_WALLET"] = "DEACTIVATE_WALLET";
    OffboardingStepName["DEACTIVATE_VIBAN"] = "DEACTIVATE_VIBAN";
    OffboardingStepName["DISABLE_AUTO_TOPUP"] = "DISABLE_AUTO_TOPUP";
    OffboardingStepName["FINAL_WALLET_UNLOAD_REQUEST"] = "FINAL_WALLET_UNLOAD_REQUEST";
    OffboardingStepName["UNSUBSCRIBE_FROM_ACCOUNTING_SERVICES"] = "UNSUBSCRIBE_FROM_ACCOUNTING_SERVICES";
    OffboardingStepName["UNSUBSCRIBE_FROM_KYC_SERVICES"] = "UNSUBSCRIBE_FROM_KYC_SERVICES";
    OffboardingStepName["WALLET_IS_EMPTY"] = "WALLET_IS_EMPTY";
    OffboardingStepName["DESTROY_CARDS"] = "DESTROY_CARDS";
    OffboardingStepName["DISABLE_TRAVELPERK_INTEGRATION"] = "DISABLE_TRAVELPERK_INTEGRATION";
})(OffboardingStepName = exports.OffboardingStepName || (exports.OffboardingStepName = {}));
var CompanyOffboardingCategory;
(function (CompanyOffboardingCategory) {
    CompanyOffboardingCategory["ACTIVE"] = "ACTIVE";
    CompanyOffboardingCategory["LEGAL"] = "LEGAL";
    CompanyOffboardingCategory["OTHER"] = "OTHER";
    CompanyOffboardingCategory["SILENT"] = "SILENT";
})(CompanyOffboardingCategory = exports.CompanyOffboardingCategory || (exports.CompanyOffboardingCategory = {}));
var CompanyOffboardingState;
(function (CompanyOffboardingState) {
    CompanyOffboardingState["CLOSED"] = "CLOSED";
    CompanyOffboardingState["CLOSING"] = "CLOSING";
})(CompanyOffboardingState = exports.CompanyOffboardingState || (exports.CompanyOffboardingState = {}));
var CompanyOffboardingReason;
(function (CompanyOffboardingReason) {
    CompanyOffboardingReason["REJECTED"] = "REJECTED";
    CompanyOffboardingReason["DUPLICATE"] = "DUPLICATE";
    CompanyOffboardingReason["BANKRUPTCY"] = "BANKRUPTCY";
    CompanyOffboardingReason["COMPETITOR"] = "COMPETITOR";
    CompanyOffboardingReason["OTHER_BREACH_OF_TERMS_AND_CONDITIONS"] = "OTHER_BREACH_OF_TERMS_AND_CONDITIONS";
    CompanyOffboardingReason["AML"] = "AML";
    CompanyOffboardingReason["CTF"] = "CTF";
    CompanyOffboardingReason["RISK_APPETITE"] = "RISK_APPETITE";
    CompanyOffboardingReason["BAD_TIMING_ONE_MONTH"] = "BAD_TIMING_ONE_MONTH";
    CompanyOffboardingReason["BAD_TIMING_THREE_MONTH"] = "BAD_TIMING_THREE_MONTH";
    CompanyOffboardingReason["BAD_TIMING_SIX_MONTH"] = "BAD_TIMING_SIX_MONTH";
    CompanyOffboardingReason["BAD_TIMING_ONE_YEAR"] = "BAD_TIMING_ONE_YEAR";
    CompanyOffboardingReason["BAD_TIMING_UNKNOWN"] = "BAD_TIMING_UNKNOWN";
    CompanyOffboardingReason["BAD_TIMING_OTHER"] = "BAD_TIMING_OTHER";
    CompanyOffboardingReason["COMPLICATED_SETUP_WALLET_LOAD"] = "COMPLICATED_SETUP_WALLET_LOAD";
    CompanyOffboardingReason["COMPLICATED_SETUP_CARD_ACTIVATION"] = "COMPLICATED_SETUP_CARD_ACTIVATION";
    CompanyOffboardingReason["COMPLICATED_SETUP_ACCOUNTING_INTEGRATION"] = "COMPLICATED_SETUP_ACCOUNTING_INTEGRATION";
    CompanyOffboardingReason["COMPLICATED_SETUP_PERSONAL_VERIFICATION"] = "COMPLICATED_SETUP_PERSONAL_VERIFICATION";
    CompanyOffboardingReason["COMPLICATED_SETUP_COMPANY_VERIFICATION"] = "COMPLICATED_SETUP_COMPANY_VERIFICATION";
    CompanyOffboardingReason["MISSING_FEATURE_ACCOUNTING_INTEGRATION"] = "MISSING_FEATURE_ACCOUNTING_INTEGRATION";
    CompanyOffboardingReason["MISSING_FEATURE_CREDIT"] = "MISSING_FEATURE_CREDIT";
    CompanyOffboardingReason["MISSING_FEATURE_MULTI_CURRENCY"] = "MISSING_FEATURE_MULTI_CURRENCY";
    CompanyOffboardingReason["MISSING_FEATURE_OPEN_API"] = "MISSING_FEATURE_OPEN_API";
    CompanyOffboardingReason["MISSING_FEATURE_REPRESENTATION"] = "MISSING_FEATURE_REPRESENTATION";
    CompanyOffboardingReason["MISSING_FEATURE_SPLIT_RECEIPT"] = "MISSING_FEATURE_SPLIT_RECEIPT";
    CompanyOffboardingReason["MISSING_FEATURE_TEAM_HIERARCHY"] = "MISSING_FEATURE_TEAM_HIERARCHY";
    CompanyOffboardingReason["MISSING_FEATURE_AUTO_VAT"] = "MISSING_FEATURE_AUTO_VAT";
    CompanyOffboardingReason["MISSING_FEATURE_PDF_RECEIPTS"] = "MISSING_FEATURE_PDF_RECEIPTS";
    CompanyOffboardingReason["MISSING_FEATURE_EMAIL_RECEIPTS"] = "MISSING_FEATURE_EMAIL_RECEIPTS";
    CompanyOffboardingReason["MISSING_FEATURE_PROJECT_MANAGEMENT"] = "MISSING_FEATURE_PROJECT_MANAGEMENT";
    CompanyOffboardingReason["MISSING_FEATURE_BILLABLE_EXPENSES"] = "MISSING_FEATURE_BILLABLE_EXPENSES";
    CompanyOffboardingReason["MISSING_FEATURE_INVOICE_MANAGEMENT"] = "MISSING_FEATURE_INVOICE_MANAGEMENT";
    CompanyOffboardingReason["MISSING_FEATURE_LOUNGE_PASS"] = "MISSING_FEATURE_LOUNGE_PASS";
    CompanyOffboardingReason["MISSING_FEATURE_MULTI_LOGIN"] = "MISSING_FEATURE_MULTI_LOGIN";
    CompanyOffboardingReason["MISSING_FEATURE_TEAM_LIMITS"] = "MISSING_FEATURE_TEAM_LIMITS";
    CompanyOffboardingReason["MISSING_FEATURE_OTHER"] = "MISSING_FEATURE_OTHER";
    CompanyOffboardingReason["MISUNDERSTOOD_PRODUCT_BANK_ACCOUNT"] = "MISUNDERSTOOD_PRODUCT_BANK_ACCOUNT";
    CompanyOffboardingReason["MISUNDERSTOOD_PRODUCT_OTHER"] = "MISUNDERSTOOD_PRODUCT_OTHER";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR"] = "MOVED_TO_COMPETITOR";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR_SPENDESK"] = "MOVED_TO_COMPETITOR_SPENDESK";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR_SOLDO"] = "MOVED_TO_COMPETITOR_SOLDO";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR_MOSS"] = "MOVED_TO_COMPETITOR_MOSS";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR_RAMP"] = "MOVED_TO_COMPETITOR_RAMP";
    CompanyOffboardingReason["MOVED_TO_COMPETITOR_OTHER"] = "MOVED_TO_COMPETITOR_OTHER";
    CompanyOffboardingReason["ORGANIZATION_CLOSING_COMPANY"] = "ORGANIZATION_CLOSING_COMPANY";
    CompanyOffboardingReason["ORGANIZATION_MERGING_ENTITY"] = "ORGANIZATION_MERGING_ENTITY";
    CompanyOffboardingReason["ORGANIZATION_OTHER"] = "ORGANIZATION_OTHER";
    CompanyOffboardingReason["ORGANIZATION_PLEO_CHAMPION_LEFT"] = "ORGANIZATION_PLEO_CHAMPION_LEFT";
    CompanyOffboardingReason["PRICING_LACK_FUNCTIONALITY"] = "PRICING_LACK_FUNCTIONALITY";
    CompanyOffboardingReason["PRICING_STRUCTURE"] = "PRICING_STRUCTURE";
    CompanyOffboardingReason["PRICING_TOO_EXPENSIVE"] = "PRICING_TOO_EXPENSIVE";
    CompanyOffboardingReason["PRICING_OTHER"] = "PRICING_OTHER";
    CompanyOffboardingReason["OTHER"] = "OTHER";
    CompanyOffboardingReason["OTHER_INVALID_SIGN_UP_FAKE"] = "OTHER_INVALID_SIGN_UP_FAKE";
    CompanyOffboardingReason["OTHER_INVALID_SIGN_UP_DUPLICATED"] = "OTHER_INVALID_SIGN_UP_DUPLICATED";
    CompanyOffboardingReason["OTHER_LOW_EXPENSE_VOLUME"] = "OTHER_LOW_EXPENSE_VOLUME";
    CompanyOffboardingReason["OTHER_FEEDBACK_REFUSED"] = "OTHER_FEEDBACK_REFUSED";
    CompanyOffboardingReason["OTHER_FEEDBACK_UNANSWERED"] = "OTHER_FEEDBACK_UNANSWERED";
})(CompanyOffboardingReason = exports.CompanyOffboardingReason || (exports.CompanyOffboardingReason = {}));
//# sourceMappingURL=offboarding.js.map